import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import Swal from 'sweetalert2';
import Loader from "../../../../../customComponents/CustomLoader";

const VendorAdd = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const [userTypedd, setUserTypedd] = useState([]);
  const [vendoroptions, setVendorOptions] = useState([]);
  const [PaymentTermOptions, setPaymentTermOptions] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id");

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
   
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(()=>{
    vendortypeoptions();
  },[formData?.business_partner_id,userType!=="superadmin"])
  const vendortypeoptions = async () => {
    try {
      const response = await axiosInstance.post("/vendortype/ddlvendortype", {business_partner_id:userType==="superadmin"?formData?.business_partner_id:businessPartnerId},{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const vendoroptions = data.map((user) => ({
        value: user.ID,
        label: user.NAME,
      }));
      setVendorOptions(vendoroptions);
      const PaymentTermresponse = await axiosInstance.post(
        "/paymentterm/ddlpaymentterm",{business_partner_id:userType==="superadmin"?formData?.business_partner_id:businessPartnerId},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const Paymentdata = PaymentTermresponse.data.data.data;
      const paymentoptions = Paymentdata.map((user) => ({
        value: user.ID,
        label: user.NAME,
      }));
      console.log("paymentoptions", paymentoptions);

      setPaymentTermOptions(paymentoptions);
    } catch (error) {
      console.log(error);
    }
  };

  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");


const handleFormSubmit = async (formData) => {
  const errors = {};
  let isValid = true;
  VendorTYpeInputs.forEach((field) => {
    if (field.validation && field.validation.required) {
      if (!formData[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      } else if (field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    }
  });
  if (!isValid) {
    setValidationErrors(errors);
    return;
  }
 
  const confirmation = await Swal.fire({
    title: "Create Vendor",
    text: "Do you want to create this vendor?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
  });
  if (confirmation.isConfirmed) {
    try {
      setLoading(true);
      const payload = {
        vendor_type_id: formData.vendortype,
        companyname: formData.companyname,
        contactno: formData.contact_no,
        email_id: formData.email_id,
        pincode: formData.pincode,
        country_id: formData.country_id,
        state_id: formData.state_id,
        city_id: formData.city_id,
        address: formData.address,
        paymentterm_id: formData.paymentterms,
        bankname: formData.bankname,
        ifsc: formData.ifsc,
        accountno: formData.accountno,
        panno: formData.panno,
        gstno: formData.gstno,
        tinno: formData.tin,
        aadharno: formData.adhaar,
        status: formData.status === "Active" ? 1 : 0,
      };
      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }
      const response = await axiosInstance.post('/vendor/create', payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      console.log("Vendor added successfully:", response.data);
      if (response.status === 200) {
        await Swal.fire({
          title: "Success",
          text: "Vendor created successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/admin/manage-logistic/vendor-master");
      }   

    } catch (error) {
      console.error('Error adding vendor:', error);
      const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
      await Swal.fire({
        title: "Something went wrong",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  } else {
    setLoading(false); // Ensure loading is reset if canceled
  }
};


  const backNavigate = () => {
    navigate(ROUTES_NAVIGATION.VENDORLIST);
  };

  const VendorTYpeInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
          },
        ]
      : []),
    {
      name: "vendortype",
      label: "Vendor Type",
      placeholder: "Enter VendorType Name",
      type: "dropdown",
      options: vendoroptions,
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "companyname",
      label: "Vendor Name",
      placeholder: "Enter Vendor Name",
      type: "text",
      required: true,
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9\s]*$/,
        message: "Only alphabets and digits are allowed*",
      },
      gridClass: "col-lg-4",
    },
    {
      name: "contact_no",
      label: "Contact No.",
      placeholder: "Enter Contact No.",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { 
        required: true, pattern: /^[6-9]/ ,
        minLength:10,
        maxLength:10,
        message1: "Contact no should start with 6, 7, 8, 9",
        message: "Please enter a valid 10-digit",
      }
    },
    {
      name: "email_id",
      label: "Email Address",
      placeholder: "Enter Email Address",
      type: "email",
      required: true,
      gridClass: "col-lg-4",
      validation: {
        required: true,
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Please enter a valid Email Address",
      },
    },
    {
      name: "pincode",
      label: "Pin Code",
      type: "text",
      required: true,
      placeholder: "Enter Pin Code",
      gridClass: "col-lg-4",
      validation: { required: true, maxLength: 6 },
    },
    {
      name: "country",
      label: "Country",
      placeholder: "Country",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      disabled: true,
      validation: { required: false },
    },
    {
      name: "state",
      label: "State",
      type: "text",
      required: true,
      placeholder: "State",
      gridClass: "col-lg-4",
      disabled: true,
      validation: { required: false },
    },
    {
      name: "city",
      label: "City",
      type: "text",
      required: true,
      placeholder: "City",
      gridClass: "col-lg-4",
      disabled: true,
      validation: { required: false },
    },
    {
      name: "address",
      label: "Address",
      type: "text",
      required: true,
      placeholder: "Enter Address",
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "panno",
      label: "PAN No.",
      type: "text",
      placeholder: "Enter PAN No.",
      validation: {
        required: false,
        pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        message: "Please enter a valid 10-character PAN number",
        maxLength:10
      },
      required: false,
      gridClass: "col-lg-4",
    },
    {
      name: "gstno",
      label: "GST No.",
      type: "text",
      placeholder: "Enter GST No.",
      validation: {
        required: false,
        maxLength:15
      },
      required: false,
      gridClass: "col-lg-4",

    },
    {
      name: "adhaar",
      label: "Aadhaar No.",
      type: "text",
      placeholder: "Enter Aadhaar No.",
      validation: {
        required: false,
        pattern: /^\d{12}$/,
        message: "Please enter a valid 12-digit Aadhar number",
        maxLength: 12,
      },
      required: false,

      gridClass: "col-lg-4",
    },
    {
      name: "tin",
      label: "Tin No.",
      type: "text",
      placeholder: "Enter Tin No.",
      validation: {
        required: false,
        // pattern: /^\d{12}$/,
        // message: "Please enter a valid 12-digit Aadhar number",
       maxLength:11,
      },
      required: false,

      gridClass: "col-lg-4",
    },
    {
      name: "paymentterms",
      label: "Payment Term",
      type: "dropdown",
      required: true,
      options: PaymentTermOptions,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "bankname",
      label: "Bank Name",
      type: "text",
      placeholder: "Enter Bank Name",
      required: true,
      validation: {
        required: true,
        pattern: /^[a-zA-Z0-9 ]+$/,
        message: "Only Alphabets digits Are Allowed*",
        maxLength: 25,
      },
      gridClass: "col-lg-4",
    },
    {
      name: "ifsc",
      label: "IFSC code",
      type: "text",
      placeholder: "Enter IFSC Code",
      required: true,
      validation: {
        required: true,
        pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/,
        message: "Please Enter Valid IFSC Code*",
        maxLength:12
      },
      gridClass: "col-lg-4",
    },
    {
      name: "accountno",
      label: "Account Number",
      type: "text",
      placeholder: "Enter Account Number",
      required: true,
      validation: {
        required: true,
        pattern: /^\d{9,18}$/,
        message: "Please Enter valid Account Number",
        maxLength: 18,
      },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { id: 1, label: "Active", value: "Active" },
        { id: 0, label: "Inactive", value: "Inactive" },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img onClick={backNavigate} src={backicon} alt="back" />
              <span className="backbtntitle">Add Vendor</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter the Vendor Details
              </span>
              <DynamicForm
                formConfig={VendorTYpeInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>
            <div className="btncontainer mt-3">
              <button
                onClick={() => {
                  handleFormSubmit(formData);
                }}
                className="submit-btn"
              >
                Submit
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default VendorAdd;
